import { render, staticRenderFns } from "./CustomCard.vue?vue&type=template&id=290a2f43&scoped=true"
import script from "./CustomCard.vue?vue&type=script&lang=js"
export * from "./CustomCard.vue?vue&type=script&lang=js"
import style0 from "./CustomCard.vue?vue&type=style&index=0&id=290a2f43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a2f43",
  null
  
)

export default component.exports